import { Css_HeadingH3, HeadingH1 } from '@dreamstack/feature-components'
import type { FullBlockTableFragment } from '@dreamstack/investors-graphql'
import map from 'lodash/map'
import tail from 'lodash/tail'
import type { FunctionComponent } from 'react'
import tw, { styled } from 'twin.macro'

const FirstTd = styled.td(() => [
  tw`py-px-32 align-top text-px-16 leading-px-30 ml:(text-px-20 leading-px-42)`,
])
const SecondTd = styled.td(() => [
  tw`py-px-32 align-top pl-px-12 md:pl-px-48 lg:pl-px-64`,
  Css_HeadingH3,
])

export const TableFinanceCalendar: FunctionComponent<React.PropsWithChildren<{
  block: FullBlockTableFragment
}>> = ({ block }) => {
  const { table, title } = block
  const rowData: string[][] = tail(table?.tableData) || [[]]
  return (
    <div tw="w-full mt-px-48 md:(mt-px-80)">
      {title && <HeadingH1 tw="mb-px-48">{title}</HeadingH1>}
      <div tw="w-full overflow-auto">
        <table tw="w-full">
          <thead>
            <tr>
              <th tw="md:width[246px]"></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {map(rowData, (rowEntry, i) => {
              const length = rowEntry.length
              const firstTd = length > 0 ? rowEntry[0] : ''
              const secondTd = length > 1 ? rowEntry[1] : ''
              return (
                <tr key={i}>
                  <FirstTd dangerouslySetInnerHTML={{ __html: firstTd }} />
                  <SecondTd dangerouslySetInnerHTML={{ __html: secondTd }} />
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
